import React, {useState, useEffect} from 'react'
import urlUtils from '@services/urlUtils'
import AcumVersionsTable from '@components/AcumSearch/AcumVersionsTable'
import {PageHeader, MainPageWrapper} from '@appearance/styled'
import {useSongs} from '@state/uses/songs'
import {PageSubTitle, TextBtn} from '@appearance/styled'
import {useHistory} from 'react-router-dom'
import {useDanceOnAddProcess} from '@state/uses/dances'
import i18n from '@localization/i18n'

export default () => {
    const queryParams = urlUtils.getQueryParams()
    const [songId, setSongId] = useState(null)
    const history = useHistory()
    const danceOnAddProcess = useDanceOnAddProcess()
    useEffect(() => {
        if (queryParams) {
            setSongId(queryParams.id)
        }
    }, [queryParams])

    const goBack = () => {
        const paramsString = localStorage.getItem('@markidim:song_search_state')
        history.push({
            pathname: 'acum_search_song',
            search: paramsString,
        })
    }

    const songName = danceOnAddProcess?.song?.name

    return (
        <MainPageWrapper>
            <PageHeader>
                {i18n.t('akum_results_table.version_search_for_song')} -{' '}
                {songName} - {i18n.t('akum_results_table.in_the_database_of')}
            </PageHeader>
            <PageSubTitle>
                {i18n.t('akum_results_table.cant_find_the_version')}
                <TextBtn onClick={goBack}>
                    {i18n.t('akum_results_table.click_here')}
                </TextBtn>
                {i18n.t('akum_results_table.and_go_back_to_songs_screen')}
            </PageSubTitle>
            {songId && <AcumVersionsTable songId={songId} />}
        </MainPageWrapper>
    )
}
